var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.anonymousAuth && ['/'].indexOf(this.$route.path) < 0)?_c('IndexLayout'):_c('v-app',[_c('v-main',[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"height":"100%"},attrs:{"id":"layout-main-container","fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }